// extracted by mini-css-extract-plugin
module.exports = {"custom":"custom_custom__s9Zx7"};